export { default } from './ShelfLifeLogo'
